import React from 'react'
import Reflux from 'reflux'
import { Col, Row, Container } from 'reactstrap'
import { LoginStore } from 'Stores/loginStore'
import _ from 'lodash'
import verifyRequirements from 'Components/authorization.js'
import KamUsersPieChart from 'Components/dashboard/KamUsersPieChart'
import KamUsersPeriodGraph from 'Components/dashboard/KamUsersPeriodGraph'
import KamUsersCompanyChart from 'Components/dashboard/KamUsersCompanyChart'
import JyskeDashboardComponent from 'Components/dashboard/JyskeDashboardComponent'
import SantanderKamBudgetReport from 'Components/dashboard/SantanderKamBudgetReport'
import SantanderKAMSpentBudgetReport from 'Components/dashboard/SantanderKAMSpentBudgetReport'
import SantanderKAMRemainingPoints from 'Components/dashboard/SantanderKAMRemainingPoints'
import MerchandiseProductsCategoryChart from 'Components/dashboard/MerchandiseProductsCategoryChart'
import MerchandiseProductsChart from 'Components/dashboard/MerchandiseProductsChart'
import WelcomeDashboard from './zohoDashboards/welcomeDashboard'
import PowerBIDashboardFrame from './zohoDashboards/powerBiDashboardFrame'
import ClientDashboard from './clientDashboard'

export default class DefaultIndex extends Reflux.Component {
  constructor(props) {
    super(props)
    this.stores = [LoginStore]
    this.storeKeys = ['settings']
  }

  render() {
    if (
      verifyRequirements({
        requirements: {
          userRole: 'CLIENT',
          userPrivilege: 'MANAGE'
        }
      }) &&
      _.get(this.state, 'settings.features.dashboard')
    ) {
      return <ClientDashboard />
    } else if (
      verifyRequirements({
        requirements: {
          userRole: 'USER',
          userPrivilege: 'VIEW'
        }
      }) &&
      _.get(this.state, 'settings.features.dashboard') &&
      this.state.settings.userAccess === 'APPROVED'
    ) {
      return (
        <Row className='py-4'>
          <Col lg='6'>
            <KamUsersPeriodGraph />
          </Col>
          <Col lg='6'>
            <KamUsersPieChart />
          </Col>
          <Col xs='12'>
            <KamUsersCompanyChart />
          </Col>
        </Row>
      )
    } else if (_.get(this.state, 'settings.features.kamdashboard') && this.state.settings.userAccess === 'APPROVED') {
      return <JyskeDashboardComponent username={this.state.settings.userName} company={this.state.settings.userCompany} />
    } else if (
      verifyRequirements({
        requirements: {
          userRole: 'CLIENT',
          userPrivilege: 'MANAGE'
        }
      }) &&
      _.get(this.state, 'settings.features.merchandiseShopBudgetReport')
    ) {
      return (
        <Row className='py-4'>
          <Col xs='12'>
            <SantanderKamBudgetReport />
          </Col>
          <Col xs='12'>
            <SantanderKAMSpentBudgetReport />
          </Col>
          <Col xs='12'>
            <SantanderKAMRemainingPoints />
          </Col>
          <Col xs='12'>
            <MerchandiseProductsCategoryChart />
          </Col>
          <Col xs='12'>
            <MerchandiseProductsChart />
          </Col>
        </Row>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 9) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'aaa101e1-1a7d-4153-935d-dfe9ca7f405e'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 32) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'8a0e8c2d-7f3b-433e-941e-7315170480b6'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 187) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <WelcomeDashboard
                dashboardId='69771000006104679'
                dashboardToken='41c59f3c5e5657db0e589e0729e863b4'
                criteria='?ZOHO_CRITERIA=%22bi_club_brands%22.%22BrandID%22%20%3D%20187'
              />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 216) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'4405cd97-c466-45f2-ab3f-6b27a807c4d1'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 167) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'949ee991-802a-4ca0-9575-657a9fb3e8b8'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 203) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'6188c989-0cdd-4822-8b62-568bd8ad8d09'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 87) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <WelcomeDashboard dashboardId='69771000006452889' dashboardToken='44c5d3483223d9e9506fcd4732b78ded' />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 232) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'f6a2198b-6f14-4e4c-ba0b-a4173b28c263'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 149) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'92960df0-36cf-4486-be0f-8b775ac755f3'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 215) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'93de74c4-e074-4c38-ae88-11eaa5d42ad8'} />
            </Col>
          </Row>
        </Container>
      )
    } else if (this.state && this.state.settings && this.state.settings.BrandID === 154) {
      return (
        <Container style={{ maxWidth: 'unset', height: '80vh' }}>
          <Row className='justify-content-center h-100'>
            <Col xs='12'>
              <PowerBIDashboardFrame WorkspaceID={'55d6c44a-272e-4bd1-97cf-5bbdee42137e'} ReportID={'fb940a63-b773-420d-8dfb-e191efef9d33'} />
            </Col>
          </Row>
        </Container>
      )
    } else {
      return (
        <div className='app flex-row align-items-center' data-cy='welcome.container'>
          <Container>
            <Row className='justify-content-center'>
              <Col md='6'>
                <div className='clearfix'>
                  {/* <h1 className='float-left display-3 mr-4'>Start</h1> */}
                  <h1 className='text-muted text-center'>Velkommen</h1>
                  {/* <p className='text-muted float-left'>Der er sikkert en masse mere at lave i menuen.</p> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }
  }
}
